import { render, staticRenderFns } from "./groupSkuBox.vue?vue&type=template&id=58e34134&scoped=true"
import script from "./groupSkuBox.vue?vue&type=script&lang=js"
export * from "./groupSkuBox.vue?vue&type=script&lang=js"
import style0 from "./groupSkuBox.vue?vue&type=style&index=0&id=58e34134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e34134",
  null
  
)

export default component.exports